export const DEFAULT_LOCALE = "en-GB"
export const DEFAULT_TIME_ZONE = "UTC"
